export const DASHBOARD_WIDGETS = [
  {
    id: 'last-samples',
    title: 'Ultimas muestras',
    description: 'Resumen de muestras por area y estado',
    titleKey: 'dashboardCustomization.widgets.lastSamples.title',
    descriptionKey:
      'dashboardCustomization.widgets.lastSamples.description',
    previewType: 'samples',
    defaultEnabled: true,
    defaultOrder: 1,
    required: false,
    rowLock: 'first',
    size: 'wide',
    component: 'LastSamples',
    isAvailable: () => ({
      available: true,
      reason: '',
    }),
  },
  {
    id: 'powerbi-analytics',
    title: 'Analitica Power BI',
    description: 'Nutrivisor / My Smart Analytics',
    titleKey: 'dashboardCustomization.widgets.powerBiAnalytics.title',
    descriptionKey:
      'dashboardCustomization.widgets.powerBiAnalytics.description',
    previewType: 'powerbi',
    defaultEnabled: true,
    defaultOrder: 2,
    required: false,
    rowLock: null,
    size: 'analytics',
    component: 'PowerBiAnalyticsWidget',
    // La función isAvailable verifica si el usuario tiene acceso a Nutrivisor o My Smart Analytics, y devuelve un objeto con la propiedad available que indica si el widget está disponible para el usuario, y una propiedad reason que proporciona una explicación en caso de que no esté disponible.
    isAvailable: ({ permissions = {} } = {}) => ({
      available:
        permissions.canAccessNutrivisor ||
        permissions.canAccessMySmartAnalytics,
      reason: 'No tienes acceso a Nutrivisor ni a My Smart Analytics',
      reasonKey:
        'dashboardCustomization.unavailableReasons.powerBiAnalytics',
    }),
  },
  {
    id: 'sample-records',
    title: 'Registros de muestras',
    description: 'Estado de envios y solicitudes',
    titleKey:
      'dashboardCustomization.widgets.onlineSamplesRecord.title',
    descriptionKey:
      'dashboardCustomization.widgets.onlineSamplesRecord.description',
    previewType: 'records',
    defaultEnabled: true,
    defaultOrder: 3,
    required: false,
    rowLock: 'second',
    size: 'large',
    component: 'OnlineSamplesRecord',
    // La función isAvailable verifica si el usuario tiene acceso al registro de muestras, y devuelve un objeto con la propiedad available que indica si el widget está disponible para el usuario, y una propiedad reason que proporciona una explicación en caso de que no esté disponible.
    isAvailable: ({ permissions = {} } = {}) => ({
      available: permissions.canAccessSampleRecords,
      reason: 'No tienes acceso al registro de muestras',
      reasonKey:
        'dashboardCustomization.unavailableReasons.onlineSamplesRecord',
    }),
  },
  {
    id: 'complaints',
    title: 'Mis incidencias',
    description: 'Resumen de incidencias por estado',
    titleKey: 'dashboardCustomization.widgets.complaints.title',
    descriptionKey:
      'dashboardCustomization.widgets.complaints.description',
    previewType: 'complaints',
    defaultEnabled: true,
    defaultOrder: 4,
    required: false,
    rowLock: null,
    size: 'medium',
    component: 'ComplaintRecord',
    // La función isAvailable verifica si el usuario tiene permiso para ver incidencias, y devuelve un objeto con la propiedad available que indica si el widget está disponible para el usuario, y una propiedad reason que proporciona una explicación en caso de que no esté disponible.
    isAvailable: ({ permissions = {} } = {}) => ({
      available: permissions.canAccessComplaints,
      reason: 'No tienes permiso para ver incidencias',
      reasonKey:
        'dashboardCustomization.unavailableReasons.complaints',
    }),
  },
];

export function getDefaultDashboardLayout() {
  return DASHBOARD_WIDGETS.map((widget) => ({
    id: widget.id,
    enabled: widget.defaultEnabled,
    order: widget.defaultOrder,
  }));
}

export function getDashboardWidgetById(widgetId) {
  return DASHBOARD_WIDGETS.find((widget) => widget.id === widgetId);
}
